// Deal Submission spec §10 — admin client for the server-driven
// mapsTo token catalog. The admin form builder dropdown is populated
// from this list so admins can never typo a destination (Deal Submission
// spec §5.1).

import { api } from "./client";

export interface DealSubmissionMappingTokenDto {
  token: string;
  label: string;
  namespace: string;
  target: string;
  valueKind: string;
  description: string | null;
}

export const dealSubmissionMappingTokensApi = {
  list: () =>
    api.get<DealSubmissionMappingTokenDto[]>(
      "/deal-submission/mapping-tokens",
    ),
};
